<template>
  <div
    class="col-12 col-lg-10 d-flex justify-content-center align-items-center"
  >
    <div
      class="d-none d-lg-flex align-items-center justify-content-center col-lg-5 p-0 mr-4"
    >
      <img class="w-100 h-75" src="images/login.png" />
    </div>
    <div class="col-12 col-md-10 col-lg-6 p-5 bg-white shadow">
      <img class="logo-img" src="images/logo.png" />
      <p class="mt-3">
        {{ $t("login.title") }}
      </p>
      <p>{{ $t("login.message") }}</p>
      <b-form @keyup.enter="login">
        <b-form-group label="Email">
          <b-form-input
            v-model="$v.email.$model"
            :class="{ 'border border-danger': $v.email.$error }"
            name="email"
            type="email"
            required
            placeholder="example@email.com"
          />
          <li class="list-group-item px-0 border-0 py-0 mt-1">
            <span v-if="!$v.email.$error">&nbsp;</span>
            <span v-else-if="!$v.email.required" class="small text-danger">{{
              $t("form.required")
            }}</span>
            <span v-else-if="!$v.email.email" class="small text-danger">{{
              $t("form.email")
            }}</span>
          </li>
        </b-form-group>
        <b-form-group label="Password">
          <b-form-input
            v-model="$v.password.$model"
            :class="{ 'border border-danger': $v.password.$error }"
            name="password"
            type="password"
            required
            placeholder="**************"
          />
          <li class="text-danger list-group-item px-0 border-0 py-0 mt-1">
            <span v-if="!$v.password.$error">&nbsp;</span>
            <span v-else-if="!$v.password.required" class="small text-danger">{{
              $t("form.required")
            }}</span>
          </li>
        </b-form-group>
        <div class="row mb-4">
          <div class="col-12">
            <div class="col-12 col-md-12 px-0">
              <b-checkbox v-model="staySignedIn" class="d-inline-block">
                {{ $t("login.remember") }}
              </b-checkbox>
            </div>
            <div class="d-flex col-md-12 justify-content-start mt-2 px-0">
              <router-link :to="{ name: 'resetPassword' }">
                {{ $t("login.forgot_password") }}
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
      <div class="row">
        <div class="col-12 ali gn-items-center justify-content-center d-flex">
          <b-button class="px-5" variant="primary" @click.stop="login">
            {{ $t("login.enter") }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    email: null,
    password: null,
    staySignedIn: false,
    loggedIn: false
  }),
  methods: {
    ...mapActions({
      setCompany: 'company/setCompany'
    }),
    login() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$toasted.error(this.$t('form.error'))
        return
      }

      this.$auth
        .login({
          fetchUser: true,
          staySignedIn: this.staySignedIn,
          params: {
            email: this.email,
            password: this.password
          }
        })
        .then(
          () => {
            this.setUserCompanies()
          },
          () => {
            this.$toasted.error(this.$t('login.invalid'))
          }
        )
    },
    setUserCompanies() {
      this.setCompany(this.$auth.user().companies[0])
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  }
}
</script>
<style lang="scss" scoped>
.logo-img {
  width: 50%;
  height: auto;
}

.form-group {
  margin-bottom: 0;
}
</style>